import { render } from "./VUELegalFooter.vue?vue&type=template&id=87207d48&scoped=true"
import script from "./VUELegalFooter.vue?vue&type=script&lang=js"
export * from "./VUELegalFooter.vue?vue&type=script&lang=js"

import "./VUELegalFooter.vue?vue&type=style&index=0&id=87207d48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87207d48"]])

export default __exports__